import { Box } from '@mui/material'
import { responsiveIconFrameSx } from '../../theme/mobileLayout'

/**
 * Renders tinted icon boxes matching Figma dimension/program cards:
 * outer square with padding, inner clip frame, image fills the frame.
 */
export default function FigmaIconFrame({
  src,
  bgColor,
  boxSize,
  innerSize,
  sx = {},
}) {
  if (!src) return null

  return (
    <Box
      sx={{
        bgcolor: bgColor,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        ...responsiveIconFrameSx,
        ...(boxSize != null ? { width: boxSize, height: boxSize } : {}),
        ...sx,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          flexShrink: 0,
          ...(innerSize != null ? { width: innerSize, height: innerSize } : {}),
        }}
      >
        <Box
          component="img"
          src={src}
          alt=""
          aria-hidden
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            maxWidth: 'none',
            objectFit: 'contain',
            display: 'block',
          }}
        />
      </Box>
    </Box>
  )
}
